// TODO: try to get rid of this.
// Caching is additionally configures in app/assets/shared/javascripts/unpoly.js
function isCachable($link) {
  let cacheAllowed = $link.attr('up-cache') !== 'false'
  let cachableUrl = !String($link.attr('href')).match(/\/edit(\?|#|$)/)

  return cacheAllowed && cachableUrl
}


// TODO: try to get rid of this. Use global config like `config.instantSelectors` and `config.followSelectors`
function setAttributes($link, attributes) {
  let attrs = Object.assign({ 'up-instant': '', 'up-follow': true }, attributes)

  if (isCachable($link)) {
    attrs['up-preload'] = ''
  } else {
    attrs['up-cache'] = 'false'
  }

  if ($link.is('.btn:not(.btn-link)')) {
    // Buttons should not navigate on mousedown
    delete attrs['up-instant']
    delete attrs['up-follow']
  }

  $link.attr(attrs)
}

module.exports = {
  setAttributes: setAttributes,
}
